import PcRoutes from './routes/client_pc';
import MobileRoutes from './routes/client_mobile';

// 设备检测
const isMobile =
  (/AppleWebKit.*Mobile/i.test(navigator.userAgent) ||
    /MIDP|SymbianOS|NOKIA|SAMSUNG|LG|NEC|TCL|Alcatel|BIRD|DBTEL|Dopod|PHILIPS|HAIER|LENOVO|MOT-|Nokia|SonyEricsson|SIE-|Amoi|ZTE/.test(
      navigator.userAgent
    )) &&
  !/iPad/.test(navigator.userAgent);

const Env = isMobile ? 'mobile' : 'pc';
const Routers = isMobile ? MobileRoutes : PcRoutes;

// 路径映射
const pathMap = {
  '/air': '/plus',
  '/bluetooth_alarm_clock/apps': '/bluetooth-alarm-clock/apps',
  '/mi_multifunction_air_monitor/privacy': '/mi-multifunction-air-monitor/privacy',
  '/mi_temp_rh_monitor/privacy': '/mi-temp-rh-monitor/privacy',
  '/air-monitor-2': '/air-monitor-2/overview'
};

// 处理路径重定向
function handleRedirect() {
  const currentPath = window.location.pathname;
  if (pathMap[currentPath]) {
    const newPath = pathMap[currentPath];
    window.location.href = `${window.location.protocol}//${window.location.hostname}:${window.location.port}${newPath}`;
  }
}

// 触发重定向
handleRedirect();

export { Env, Routers };